




































import Component from 'vue-class-component';
import Vue from 'vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import { required } from '@/common/validation/validation';
import { FacilityFormModel } from '@/context/facility/model/FacilityFormModel';
import CustomerAutocomplete from '@/general/component/form/autocomplete/CustomerAutocomplete.vue';
import CustomerAutocompleteTS
  from '@/general/component/form/autocomplete/CustomerAutocompleteTS.vue';
import TimezoneAutocomplete from '@/general/component/form/autocomplete/TimezoneAutocomplete.vue';

@Component({
  components: {
    CustomerAutocomplete,
    CustomerAutocompleteTS,
    TimezoneAutocomplete,
    TextInput
  }
})
export default class FacilityFormTemplate extends Vue {
  @VModel({ type: Object }) model!: FacilityFormModel;
  valid = true;

  get rules(): Record<string, unknown> {
    return {
      client: [required],
      identifier: [required]
    };
  }
}
